import moment from "moment";
import momenttimezone from "moment-timezone";
import { forwardRef, useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Pagination from "../../Controls/Pagination/pagination";

const PendingRequestTable = forwardRef(function PendingRequestTable(
  {
    language,
    dateFormatValueUpper,
    selectAll,
    onPageViewDropDown,
    orgLstPendingRequestAccess,
    noRecordsFoundPendingAccess,
    paginationAttributes,
    onPageChange,
    onNextClick,
    onPrevClick,
    totalPages,
    pageView,
    isClear,
    selectedOption,
    openClickL3Access,
    applyTimeZoneToDisplay,
    timeZoneRef,
    timeZoneAbbrevation
  },
  ref
) {
  const [allChecked, setAllChecked] = useState(false);
  const selectedLanguage = useSelector((state) => state.counter);
  const pageViewRef = useRef();
  //const [count, setCount] = useState(0);
  //console.log(totalPages);
  const handlerMasterSelectionRequest = () => {
    setAllChecked(!allChecked);
    if (!allChecked) {
      ref.current.map((element) => (element.checked = true));
    } else {
      ref.current.map((element) => (element.checked = false));
    }
  };
  let count = 0;
  const handleSelectedAllRequest = () => {
    ref.current = ref.current.filter((r) => r !== null);
    for (const element of ref.current) {
      if (element.checked) count++;
      else count--;
    }

    if (ref.current.length === count) {
      setAllChecked(true);
    } else {
      setAllChecked(false);
    }
  };
  // useEffect(() => {
  //   setAllChecked(selectAll);
  // }, [orgLstPendingRequestAccess, isClear]);

  const PrevClick = () => {
    onPrevClick();
  };
  const rowclick = (id) => {
    openClickL3Access(id);
  };
  const NextClick = () => {
    onNextClick();
  };
  const PageChange = (i) => {
    onPageChange(i);
  };

  const setpageViewDrp = () => {
    onPageViewDropDown(pageViewRef.current.value);
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const stickySection = document.querySelector(".sticky-section");
  //     if (window.scrollY >= stickySection.offsetTop - (-75)) {
  //       setIsSticky(true);
  //     } else {
  //       setIsSticky(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };

  // }, []);
  const [isSticky, setIsSticky] = useState(false);
  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if((scrollTop) < 135)
      setIsSticky(false);
    else if(scrollTop > 135)
      setIsSticky(true)
  };

  useEffect(() => {
    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className="card-body p-0"
      style={{ paddingRight: "0.15rem !important" }}
    >
       <div className="table-responsive res-card" style={{marginTop: ` ${isSticky ? "47px" : "0px"}`}}>
        <table
          className="fold-table table tablelayout "
          cellPadding="0"
          cellSpacing="0"
        >
           {/* <thead className={` bg-lightblue sticky-section ${isSticky ? 'fixed-accessManage' : ""}`}> */}
           <thead id="sticky2" className={` ${isSticky ? "bg-lightblue sticky-fixed-accessrquest" : "bg-lightblue"}`}
          style={{ top: ` ${isSticky ? "75px" : ""}`}}>
            <tr className="">
            {(selectedOption!=language.UI_MyRequests)?
              <th className="w-5p res-pr-0 pe-0 checkbox-cell">
                <div className="checkbox res-ml ms-22">
                  <label className="p-0 mb-0">
                    <input
                      type="checkbox"
                      checked={allChecked}
                      value={allChecked}
                      onChange={handlerMasterSelectionRequest}
                    />
                    <span className="cr">
                      <i className="cr-icon material-icons">check</i>
                    </span>
                  </label>
                </div>
              </th>:''}
              <th className="w-5p text-center">{language.UI_Type}</th>
              <th className="w-14p pl-5px">{language.docID}</th>
              <th className="w-14p pl-5px">{language.subject}</th>
              <th className="w-14p pl-5px">{language.UI_DocumentName}</th>
             {(selectedOption!=language.UI_MyRequests)?<th className="w-16p pl-5px">{language.readers}</th>:''}
             {selectedOption === language.UI_MyRequests ? (
                <th className="w-16p pl-5px">
                  {selectedLanguage.LstLanguageCodes.UI_Owner}
                </th>
              ) : (
                ""
              )}
              <th className="w-12p pl-5px">{language.UI_RequestedDate}</th>
              <th className="w-12p text-start">{language.UI_Reason}</th>
              <th className="w-8p text-start">{language.status}</th>
            </tr>
          </thead>

          <tbody>
            {orgLstPendingRequestAccess.length > 0 &&
              orgLstPendingRequestAccess.map((item, i) => (
                <>
                 <tr className={"borderrow"}>
                    <td colSpan={9} className="innertTableTd">
                      <table
                        className="table-layout aiAutolockTable"
                        cellPadding="0"
                        cellSpacing="0"
                      >
                <tr
                 className={item.open == true ? "open view" : "view"}
                   onClick={(e) => rowclick(item.id)}
                  style={{ borderBottom: "0.1rem solid #e7e5e570" }}
                  id={"trMain" + i}
                  key={i}
                >
                 {(selectedOption!=language.UI_MyRequests)?
                  <td
                    className="text-start w-5p td-checkbox">
                    <div
                      className="checkbox mt-n5p marginTop8 res-ml-n8 ">
                      <label className="p-0 mb-0">
                        <input
                          type="checkbox"
                          ref={(el) => (ref.current[i] = el)}
                          onChange={handleSelectedAllRequest}
                        />
                        <span className="cr">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                      </label>
                    </div>
                  </td>:''}
                  <td
                    className="w-5p text-center"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    {item.rpdType !== undefined && item.rpdType === "Create" ? (
                      <img className="create-img" src="assets/img/icons/create.svg" height="28px" />
                    ) : (
                      <span className="material-icons top3">mail </span>
                    )}
                  </td>
                  <td
                    className="text-start w-14p "
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.documentId}
                    >
                      <p className="textwrap mb-0">{item.documentId}</p>
                    </div>
                  </td>
                  <td
                    className="text-start w-14p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.subject}
                    >
                      <p className="textwrap mb-0">{item.subject}</p>
                    </div>
                  </td>
                  <td
                    className="text-start w-14p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.documentName}
                    >
                      <p className="textwrap mb-0">{item.documentName}</p>
                    </div>
                  </td>
                  {(selectedOption!=language.UI_MyRequests)?
                  <td
                    className="text-start w-16p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.readerEmail}
                    >
                      <p className="textwrap mb-0">{item.readerEmail}</p>
                    </div>
                  </td>:''}
                  {selectedOption === language.UI_MyRequests ? (
                    <td
                      className="text-start w-16p"
                      style={{
                        borderLeft: "0.1rem solid #e7e5e570",
                      }}>
                      <div
                        className="d-flex flex-wrap Wordbreak"
                        title={item.senderEmail}>
                        <p className="textwrap mb-0">{item.senderEmail}</p>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                  <td
                    className="text-start w-12p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div className="d-flex flex-wrap textwrap">
                      {moment.utc(applyTimeZoneToDisplay(new Date(item.createdDate), timeZoneRef.current))
                        .format(dateFormatValueUpper + " HH:mm")}
                    </div>
                  </td>
                  <td
                    className="text-start w-12p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                    }}
                  >
                    <div
                      className="d-flex flex-wrap Wordbreak"
                      title={item.readerNotes}
                    >
                      <p className="textwrap mb-0">{item.readerNotes}</p>
                    </div>
                  </td>
                  <td
                    className="text-start w-8p"
                    style={{
                      borderLeft: "0.1rem solid #e7e5e570",
                      wordBreak: "normal",
                    }}
                  >
                    <div className="d-flex flex-wrap textwrap">
                    {item.status === "Pending" ? selectedLanguage.LstLanguageCodes.UI_Pendingtxt: (item.status === "Approved" ? selectedLanguage.LstLanguageCodes.UI_Approvedtxt : selectedLanguage.LstLanguageCodes.UI_Declinedtxt)}
                    </div>
                  </td>
                </tr>
                </table>
                </td>
                </tr>
                   {item.open == true && (
                                    <tr className="fold open">
                                      <td colSpan="9" className="">
                                        <div
                                          className="fold-content mb-3"
                                          style={{
                                            padding: "0em",
                                            boxShadow: "none",
                                          }}
                                        >
                                          <div className="row mt-4 mt-n1 mx-0 cardborder">
                                            <div
                                              className="bg-white mt-1"
                                              style={{ width: "45%" }}
                                            >
                                              <table className="table table-borderless">
                                                <tbody>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_Owner
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.senderEmail}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_FirstName
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.firstName}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_LastName
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.lastName}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_MobileNumber
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      <div className="d-flex flex-wrap textwrap">
                                                        {item.mobileNumber}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                     {item.status != "Pending" && (
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {item.status == "Declined" ?
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_DeclinedDate :selectedLanguage.LstLanguageCodes.UI_ApprovedDate
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                        <div className="d-flex flex-wrap textwrap">
                                          {
                                            moment.utc(
                                              applyTimeZoneToDisplay(
                                              new Date(item.modified),
                                                timeZoneRef.current
                                              )
                                            ).format(dateFormatValueUpper + " HH:mm") +
                                            " " +
                                            "("+timeZoneAbbrevation.current +")"
                                          }
                                        </div>

                                                    </td>
                                                  </tr>
                                                  )}
                                                  {item.status != "Pending" && (
                                                  <tr>
                                                    <td className="w-38 border-0 font-lighter">
                                                      {( item.status == "Declined" ?
                                                        selectedLanguage.LstLanguageCodes
                                                          .UI_DeclinedBy :selectedLanguage.LstLanguageCodes.UI_ApprovedBy)
                                                      }
                                                      :
                                                    </td>
                                                    <td className="f-w550 border-0">
                                                      { (( item.status == "Declined" || item.status == "Approved") ? item.modifiedBy != null &&
                                                        item.modifiedBy:"")}
                                                    </td>
                                                  </tr>
                                                  )}

                                                </tbody>
                                              </table>
                                            </div>

                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                </>
              ))}
            {noRecordsFoundPendingAccess == true && (
              <tr>
                <td colSpan={8} style={{ textAlign: "center" }}>
                  {language.UI_NoRecordsFound}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="row d-flex align-items-center justify-content-between">
        <p className="w-auto ms-3">
          <label
            htmlFor="pageView"
            className="radio-label font-w600 control res-w  res-left12"
            style={{ paddingTop: "9px", paddingRight: "5px" }}
          >
            {pageView}:
          </label>
          <select
            className=""
            name="documentIdInput"
            ref={pageViewRef}
            // value={pageView}
            onChange={setpageViewDrp}
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </p>
        {totalPages > 1 ? (
          <Pagination
            {...paginationAttributes}
            onPrevClick={PrevClick}
            onNextClick={NextClick}
            onPageChange={(i) => PageChange(i)}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});
export default PendingRequestTable;
